import { SelectField } from '@mi-front/ui';
import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { getGipStationIds } from '../get-gip-station-ids';
import { useGipVersionsQuery } from '../hooks/useGipVersionsQuery';
import { GipReportValues } from '../types';

/** Versions multi-select, loaded from GIP metadata for the selected advertisers and campaigns. */
export function VersionsField() {
  const { $t } = useIntl();
  const { values } = useFormikContext<GipReportValues>();
  const queryEnabled = !!(values.advertisers.length && values.campaigns.length);

  const query = useGipVersionsQuery(
    {
      from: values.from,
      to: values.to,
      stations: getGipStationIds(values),
      advertisers: values.advertisers.map((v) => v.name),
      campaigns: values.campaigns.map((v) => v.name),
    },
    queryEnabled,
  );

  return (
    <SelectField
      name="versions"
      label={$t({
        id: 'audit.gipReport.form.versions',
        defaultMessage: 'Versiones',
      })}
      placeholder={$t({
        id: 'audit.gipReport.form.allVersions',
        defaultMessage: 'Todas las versiones',
      })}
      options={query.data?.map((name) => ({ name }))}
      multiple
      isClearable
      isSearchable
      getOptionLabel={(value) => value.name}
      getOptionValue={(value) => value.name}
      isLoading={query.isFetching}
    />
  );
}
